<template>
    <div>
        <div>
            <apexcharts
                v-if="show"
                width="100%"
                height="300"
                type="bar"
                :options="chartOptions"
                :series="series"
            ></apexcharts>
        </div>
        <div v-if="!show" class="mt-5">
            <v-row>
                <v-col cols="12">
                    <v-skeleton-loader
                        type="card"
                        height="320"
                        width="100%"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
    name: "Chart",
    components: {
        apexcharts: VueApexCharts,
    },
    props: {
        data: { type: Object, required: true },
    },
    data() {
        return {
            chartOptions: {
                chart: {
                    id: "basic-bar",
                    animations: {
                        speed: 1000,
                    },
                    toolbar: {
                        show: true,
                        tools: {
                            download: false,
                        },
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                plotOptions: {
                    bar: {
                        distributed: true,
                        horizontal: true,
                    },
                },
                xaxis: {
                    categories: [],
                },
                legend: {
                    show: false,
                },
                colors: [],
            },
            series: [
                {
                    name: "",
                    data: [],
                },
            ],
            show: false,
            answer: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"],
            reload: false,
        };
    },
    watch: {
        data: {
            handler() {
                if (this.reload) {
                    this.show = false;
                    this.series[0].data = [];
                    this.chartOptions.xaxis.categories = [];
                    setTimeout(() => {
                        this.show = true;
                        for (var a = 0; a < this.data.total_choice; a++) {
                            this.series[0].data.push(this.data[this.answer[a]]);
                        }
                        this.series[0].data.forEach((arr, index) => {
                            this.chartOptions.xaxis.categories.push(
                                `${this.answer[index]}`,
                            );
                        });
                    }, 500);
                }
            },
        },
    },
    created() {
        // alert(JSON.stringify(this.data));
        this.show = false;
        setTimeout(() => {
            this.show = true;
            for (var a = 0; a < this.data.total_choice; a++) {
                this.series[0].data.push(this.data[this.answer[a]]);

                let color = null;
                if (this.answer[a] === this.data.quiz_answer) {
                    color = "#4ad295";
                } else {
                    color = "#92b1d1";
                }

                this.chartOptions.colors.push(color);
            }

            this.series[0].data.forEach((arr, index) => {
                this.chartOptions.xaxis.categories.push(
                    `${this.answer[index]}`,
                );
            });
            this.reload = true;
        }, 500);
    },
    methods: {
        updateTheme() {
            this.chartOptions = {
                colors: ["#ff6a98", "#5a74b1", "#26b3d3", "#4ad295", "#fdc74a"],
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// BarChart.vue?152af12f